import { ShieldCheck } from "lucide-react";
import { Reveal } from "./Reveal";
import { SubscribeButton } from "./SubscribeButton";
import { ReferralInput } from "./ReferralInput";

export const FinalCta = () => (
  <section data-testid="final-cta-section" className="relative overflow-hidden bg-purple-700">
    <span
      aria-hidden="true"
      className="pointer-events-none absolute -bottom-24 left-1/2 -translate-x-1/2 select-none font-heading text-[24vw] font-extrabold leading-none text-white/5"
    >
      997€
    </span>
    <div className="relative mx-auto max-w-4xl px-5 py-16 text-center">
      <Reveal>
        <h2 className="font-heading text-3xl font-extrabold tracking-tight text-white sm:text-4xl">
          Smetti di regalare soldi alle agenzie.
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-base text-purple-100">
          Un anno intero di marketing seguito da noi, con shooting fotografico incluso. Meno del costo di una cena al
          mese.
        </p>
        <div className="mt-7 flex flex-col items-center justify-center">
          <SubscribeButton
            testid="final-subscribe-cta-button"
            className="bg-white !text-purple-700 hover:bg-purple-50"
          />
          <ReferralInput suffix="final" dark />
        </div>
        <p className="mt-6 flex items-center justify-center gap-2 text-xs text-purple-200">
          <ShieldCheck className="h-4 w-4" /> Pagamento sicuro con Stripe · Nessun rinnovo automatico
        </p>
      </Reveal>
    </div>
  </section>
);

export const Footer = () => (
  <footer data-testid="footer" className="border-t border-purple-100 bg-white">
    <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-4 px-5 py-8 sm:flex-row">
      <img src="/logo.png" alt="MIR-IA" data-testid="footer-logo-img" className="h-8 w-auto" />
      <div className="text-center sm:text-right">
        <p className="text-xs text-slate-400">
          La piattaforma dalla parte dei liberi professionisti e piccole attività.
        </p>
        <p data-testid="footer-rights" className="mt-1 text-xs font-semibold text-slate-500">
          Mir-IA — Tutti i diritti riservati · License number 2541494, Sharjah Media City
        </p>
        <p className="mt-1.5 flex items-center justify-center gap-3 text-xs sm:justify-end">
          <a href="/privacy-policy" data-testid="footer-privacy-link" className="text-purple-600 underline-offset-2 transition-colors hover:text-purple-800 hover:underline">
            Privacy Policy
          </a>
          <span className="text-slate-300">·</span>
          <a href="/termini-di-vendita" data-testid="footer-termini-link" className="text-purple-600 underline-offset-2 transition-colors hover:text-purple-800 hover:underline">
            Termini di vendita
          </a>
        </p>
      </div>
    </div>
  </footer>
);
